import ApiService from "@/api/ApiService";
import { useQueryClient } from "@tanstack/react-query";

export function useJobKeys() {
  const queryClient = useQueryClient();

  const fetchJobKeys = (phaseId: number, resourceId?: number) => {
    const queryKey = !!resourceId
      ? ["jobKeys", "r", resourceId, phaseId]
      : ["jobKeys", "p", phaseId];
    // Try to get cached data synchronously
    const state = queryClient.getQueryState(queryKey);
    if (!!state && !state.isInvalidated) {
      return state.data;
    }

    // If no cached data, trigger fetch in the background
    queryClient.fetchQuery({
      queryKey,
      queryFn: !!resourceId
        ? ApiService.getResourceKeys(resourceId, phaseId)
        : ApiService.getJobKeys(phaseId),
    });

    return null; // Data is still loading
  };

  return { fetchJobKeys };
}
